module.exports = __webpack_public_path__ + "static/media/uod_logo.ef18eb66.svg";